import React from 'react';
import { Link } from '@xo-union/tk-component-buttons';
import styles from './styles.scss';
import { Body1, H4 } from '@xo-union/tk-ui-typography';

export interface CalloutCardProps {
  title?: string;
  description?: string;
  linkText?: string;
  linkTo?: string;
  imageSrc?: string;
  onClick?: () => void;
  ['data-testid']?: string;
}

export const CalloutCard: React.FC<CalloutCardProps> = ({
  title,
  description = '',
  linkText,
  linkTo,
  imageSrc,
  onClick,
  ...rest
}) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <img className={styles.image} src={imageSrc} alt={title} />
    </div>
    <div className={styles.contentContainer}>
      <H4 className={styles.title}>{title}</H4>
      <Body1 className={styles.description}>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </Body1>
      <div className={styles.buttonContainer}>
        <Link color="secondary-alternative" size="sm" href={linkTo} target="_blank" onClick={onClick} {...rest}>
          {linkText}
        </Link>
      </div>
    </div>
  </div>
);
